import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { SettingsPaths } from "Settings/Routes/Routing";
import { Dns, Settings } from "@mui/icons-material";
import { ListItemButton, ListItemText, Stack } from "@mui/material";
import { useMatch, useNavigate, useParams } from "react-router";

const verticalSetup = Resources.base.settings.verticalSetup;

export const verticalSetupItems = [
	{
		key: "orderSetup",
		icon: <Dns />,
		urlPath: (marketId: number, verticalId: number) =>
			SettingsPaths.OrderSetup.path(marketId, verticalId),
	},
	{
		key: "generalSetup",
		icon: <Settings />,
		urlPath: (marketId: number, verticalId: number) =>
			SettingsPaths.GeneralSetup.path(marketId, verticalId),
	},
] as const;

export const VerticalSetupList = () => {
	const { t } = useResource();
	const navigate = useNavigate();
	const { marketId, verticalId } = useParams();

	const paramsMarketId = marketId ? Number(marketId) : undefined;
	const paramsVerticalId = verticalId ? Number(verticalId) : undefined;

	const matches = {
		orderSetup: useMatch(
			paramsMarketId && paramsVerticalId
				? SettingsPaths.OrderSetup.path(paramsMarketId, paramsVerticalId)
				: "",
		),
		generalSetup: useMatch(
			paramsMarketId && paramsVerticalId
				? SettingsPaths.GeneralSetup.path(paramsMarketId, paramsVerticalId)
				: "",
		),
	};

	return (
		<Stack
			direction="row"
			spacing={1}
			sx={{
				width: "100%",
				overflowX: "auto",
				pb: 1,
			}}
		>
			{verticalSetupItems?.map(
				(setup) =>
					paramsMarketId &&
					paramsVerticalId && (
						<ListItemButton
							selected={!!matches[setup.key]}
							key={setup.key}
							onClick={() =>
								navigate(setup.urlPath(paramsMarketId, paramsVerticalId))
							}
							sx={{
								gap: 1,
								minWidth: "fit-content",
								borderRadius: 1,
								px: 2,
								py: 1,
								flexShrink: 0,
							}}
						>
							{setup.icon}
							<ListItemText
								sx={{
									whiteSpace: "nowrap",
									"& .MuiListItemText-primary": {
										fontSize: "0.875rem",
									},
								}}
							>
								{t(verticalSetup[setup.key])}
							</ListItemText>
						</ListItemButton>
					),
			)}
		</Stack>
	);
};
